const { checkinLaterState } = require("../../../shared/managers/checkin-later-manager");

function getElement (value, ids) {
    for (var i = 0; i < ids.length; i++) {
      var el = $(ids[i]);
      if(el.val() === value) {
        return el;
      }
    }
    return el;
}

var MultipleGuestServiceProviderModel = Backbone.Epoxy.Model.extend({
  initialize: function() {
    Backbone.Validation.bind(this, { liveValidation: true });

    this.listenTo(this, 'change:service', _.bind(this.notifyServiceChanged, this));
    this.listenTo(this, 'change:provider', _.bind(this.notifyProviderChanged, this));
  },

  cleanup: function() {
    this.stopListening();
  },

  defaults: {
    index: 0,
    guest: 1,
    service: null,
    provider: null,
    estimatedWaitTime: 0,
    firstName: null,
    lastName: null,
    fullName: '',
    overWaitTimeMessage: 'Wait time is too long, try again later'
  },

  notifyServiceChanged: function() {
    this.trigger('service:changed', this);
  },

  notifyProviderChanged: function() {
    this.trigger('provider:changed', this);
  },

  computeds: {
    serviceId: {
      deps: ['service'],
      get: function() {
        var service = this.get('service');
        return (service == null) ? null : service.get('id');
      },
      set: function(value) {
        var service = bookedby.app.serviceManager.serviceMap[value] || null;
        this.set('service', service);
      }
    },
    providerId: {
      deps: ['provider'],
      get: function() {
        var employee = this.get('provider');
        return (employee == null) ? null : employee.get('id');
      },
      set: function(value) {
        var employee = bookedby.app.serviceManager.employeeMap[value] || null;
        this.set('provider', employee);
      }
    },
    guestLabel: {
      deps: ['guest'],
      get: function() {
        var index = this.get('guest');
        return 'Guest ' + index;
      }
    },

    estimatedWaitTimeText: {
      get: function() {
        var estimatedWaitTime = bookedby.helpers.secondsToMinutesRoundable(this.get('estimatedWaitTime'), 1);
        return estimatedWaitTime + ' min.';
      }
    },

    mainUser: {
      deps: ['guest'],
      get: function() {
        var index = this.get('guest');
        return index == 1;
      }
    },

    fullNameFormat: {
      deps: ['fullName'],
      get: function(fullName) {
        return fullName;
      },
      set: function(fullName) {
        if (_.isEmpty(fullName))
          return { fullName: fullName };

        var guestNameArgs = fullName.split(' ');
        guestNameArgs = _.filter(guestNameArgs, function(args) {
          return !_.isEmpty(args);
        });

        return { fullName: guestNameArgs.join(' ') };
      }
    },

    useCheckinLater: function() {
      return checkinLaterState.getUseCheckinLater();
    },

    isEmployeeFA: {
      deps: ['provider'],
      get: function() {
        const employee = this.get('provider');
        return employee === null
      }
    },
  },

  validation: {
    /*firstName: {
      required: true,
      msg: 'Please enter guest\'s first name.'
    },
    lastName: {
      required: true,
      msg: 'Please enter  guest\'s last name.'
    },*/
    fullName: [
        {
            fn: function (value) {
                var el = getElement(value, ["#guest_name_1", "#guest_name_2", "#guest_name_3"]);
                if (!value) {
                    el.attr("aria-invalid", "true");
                    return 'Please enter a name for the guest.';
                }
                if (!/^[A-Za-z\s\-\\']+$/.test(value)) {
                    el.attr("aria-invalid", "true");
                    return 'Please enter a valid name for the guest';
                }
                if (value.trim().split(' ').length <= 1) {
                    el.attr("aria-invalid", "true");
                    return 'Please enter the guest\'s full name.';
                }
                el.attr("aria-invalid", "false");
            }
        },
    ]
  }

});

module.exports = MultipleGuestServiceProviderModel;
